import { DashboardDefaultMedia } from '@organization/features/dashboard/components'
import {
  MediaWidget,
  WidgetFunctionProps
} from '@organization/features/dashboard/types'
import { Card, Flex } from 'antd'

import { ArrowRight, Youtube } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useStyle } from './styles'
import { DashboardVideo } from '../DashboardVideo'

interface Props {
  instance: MediaWidget
}

interface MediaTypesComponent {
  video: React.FC<WidgetFunctionProps<MediaWidget>>
  default: React.FC<WidgetFunctionProps<MediaWidget>>
}

const mediaTypesComponentsMapping: MediaTypesComponent = {
  video: DashboardVideo,
  default: DashboardDefaultMedia
}

export const DashboardMedia = ({ instance }: Props) => {
  const Component: React.FC<WidgetFunctionProps<MediaWidget>> =
    mediaTypesComponentsMapping[instance.media_type] ||
    mediaTypesComponentsMapping['default']

  const { t } = useTranslation()
  const { styles } = useStyle()

  return (
    <Card
      className={styles.mediaCard}
      title={
        <Flex align="center" gap={8}>
          <Youtube size={18} />
          {instance.title}
        </Flex>
      }
      extra={
        <Link to={instance?.redirect_url} target="_blank">
          <Flex align="center" gap={8}>
            {t('common.view_all')}
            <ArrowRight size={16} />
          </Flex>
        </Link>
      }
    >
      <Component instance={instance} />
    </Card>
  )
}
